<template>
    <div>
        <div id="modal_move" class="modal fade hidden-print" data-name="move" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" style="width: 100%; padding-left: 15px; max-width: 1550px;">
                <div class="modal-content" style="width: 100%;">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="reset()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">
                            {{trans('warehouseman.move.title')}}
                        </h4>
                    </div>
                    <div v-show="loading == 0">
                        <div class="modal-body compact-errors">
                            <div class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <dc-core-single-select
                                            v-if="!areCheckedShifts"
                                            v-model="form.data.warehouseFrom"
                                            :options="warehouses"
                                            :errors="form.options.errors"
                                            name="warehouseFromId"
                                            :show-labels="false"
                                            :custom-label="translateListObj"
                                            :title="trans('warehouseman.prepare.search.warehouse_from')"
                                            @dispatch="warehouseSelected"
                                    >
                                    </dc-core-single-select>
                                    <div v-if="areCheckedShifts" class="row form-group" style="margin-bottom: 5px">
                                        <div class="col-md-3 control-label">
                                            {{trans('warehouseman.move.search.warehouse_from')}}
                                        </div>
                                        <div class="col-md-9">
                                            <span v-if="form.data.warehouseFrom">{{ form.data.warehouseFrom.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <dc-core-single-select
                                        v-if="form.data.externalIssue"
                                        v-model="form.data.supplier"
                                        :checked="form.data.supplier"
                                        :options="suppliers"
                                        :show-labels="false"
                                        :custom-label="translateListObj"
                                        :errors="form.options.errors"
                                        name="supplierId"
                                        :title="trans('warehouseman.move.search.to_supplier')"
                                    />
                                </div>
                            </div>

                            <div v-if="!form.data.externalIssue" class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <dc-core-single-select
                                            v-if="!areCheckedShifts"
                                            v-model="form.data.warehouseTo"
                                            :checked="form.data.warehouseTo"
                                            :options="warehouses"
                                            :errors="form.options.errors"
                                            name="warehouseToId"
                                            label="name"
                                            :show-labels="false"
                                            :custom-label="translateListObj"
                                            :title="trans('warehouseman.prepare.search.warehouse_to')"
                                    >
                                    </dc-core-single-select>
                                    <div v-if="areCheckedShifts" class="row form-group" style="margin-bottom: 5px">
                                        <div class="col-md-3 control-label">
                                            {{trans('warehouseman.move.search.warehouse_to')}}
                                        </div>
                                        <div class="col-md-9">
                                            <span v-if="form.data.warehouseTo">{{ form.data.warehouseTo.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <dc-core-single-select
                                            v-model="form.data.deliver"
                                            :checked="form.data.deliver"
                                            :options="users"
                                            :errors="form.options.errors"
                                            name="deliverId"
                                            :show-labels="false"
                                            :custom-label="translateUserListObj"
                                            :title="trans('warehouseman.move.search.deliver')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <div class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <dc-core-single-select
                                            v-if="!form.data.externalIssue"
                                            v-model="form.data.receiver"
                                            :checked="form.data.receiver"
                                            :options="users"
                                            :errors="form.options.errors"
                                            name="receiverId"
                                            :show-labels="false"
                                            :custom-label="translateUserListObj"
                                            :title="trans('warehouseman.move.search.receiver')"
                                    >
                                    </dc-core-single-select>
                                </div>
                            </div>

                            <div v-if="!areCheckedShifts" class="row" style="margin-bottom: 5px">
                                <div class="col-md-6">
                                    <checkbox
                                            v-model="form.data.externalIssue"
                                            :label="trans('warehouseman.prepare.search.external_issue')"
                                    />
                                </div>
                            </div>

                            <table class="table table-condensed" style="margin-bottom: 0;">
                                <thead>
                                <tr>
                                    <th>{{trans('warehouseman.move.table.object_type')}}</th>
                                    <th style="width: 300px;">{{trans('warehouseman.move.table.position')}}</th>
                                    <th>{{trans('warehouseman.move.table.unit')}}</th>
                                    <th style="width: 270px;">{{trans('warehouseman.move.table.meal')}}</th>
                                    <th>{{trans('warehouseman.move.table.expected')}}</th>
                                    <th>{{trans('warehouseman.move.table.prepared')}}</th>
                                    <th>{{trans('warehouseman.move.table.final')}}</th>
                                    <th style="width: 110px">{{trans('warehouseman.move.table.execute')}}</th>
                                    <th style="width: 80px">{{trans('warehouseman.move.table.unit_price')}}</th>
                                    <th>{{trans('warehouseman.prepare.table.weight')}}</th>
                                    <th>{{trans('warehouseman.move.table.description')}}</th>
                                    <th style="width: 50px;"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(shift, i) in form.data.shifts" :key="i">
                                    <td>
                                        <simple-form-single-select
                                                v-if="!shift.item.id"
                                                v-model="shift.objectType"
                                                :options="objectTypes"
                                                :show-labels="false"
                                                :custom-label="translateObjectType"
                                                :allow-empty="false"
                                                :checked="'product'"
                                        >
                                        </simple-form-single-select>
                                        <span v-if="shift.item.id">
                                            {{ translateObjectType(shift.item.objectType) }}
                                        </span>
                                    </td>
                                    <td>
                                        <div v-if="!shift.item.id">
                                            <simple-form-single-select
                                                v-if="shift.objectType"
                                                ref="sss"
                                                :key="key"
                                                v-model="shift.object"
                                                :options="shift.objectType && objects[shift.objectType] ? objects[shift.objectType] : []"
                                                :show-labels="false"
                                                :custom-label="translateObject"
                                                :allow-empty="false"
                                                @dispatch="getUnit({$event}, i)"
                                            >
                                            </simple-form-single-select>
                                            <span v-else>
                                                {{ trans('warehouseman.common.first_choose_object_type') }}
                                            </span>
                                        </div>
                                        <div v-else>
                                            {{ shift.objectName }}
                                        </div>
                                    </td>
                                    <td>
                                        <span v-if="shift.item.id">
                                            {{ translateUnit(shift.item.unit) }}
                                        </span>
                                        <span v-if="!shift.item.id">
                                            <span v-if="shift.object">
                                                {{ translateUnit(shift.object.unit ? shift.object.unit : 'piece') }}
                                            </span>
                                            <span v-else>-</span>
                                        </span>
                                    </td>
                                    <td>
                                        <simple-form-single-select
                                                :key="key"
                                                v-model="shift.mealId"
                                                :checked="shift.mealId"
                                                :options="meals"
                                                label="nameForSelect"
                                                @dispatch="updateMealName({$event}, i)"
                                        ></simple-form-single-select>
                                    </td>
                                    <td>{{ shift.item.amountExpected }}</td>
                                    <td>{{ shift.item.amountPrepared ? shift.item.amountPrepared : 0 }}</td>
                                    <td>{{ shift.item.amountFinal ? shift.item.amountFinal : 0 }}</td>
                                    <td>
                                        <input
                                                v-model="shift.amountToMove"
                                                type="number"
                                                class="form-control"
                                        >
                                    </td>
                                    <td>
                                        <input
                                                v-model="shift.unitPrice"
                                                type="number"
                                                class="form-control"
                                                min="0"
                                                @change="updateUnitPrice(shift)"
                                        >
                                    </td>
                                    <td>{{ shift.amountToMove ? dcNumberFormat(shift.item.unitWeight * shift.amountToMove) : 0 }}</td>
                                    <td>
                                        <textarea v-model="shift.description" rows="1" class="form-control"></textarea>
                                    </td>
                                    <td>
                                        <button
                                                class="btn btn-danger btn-sm"
                                                :disabled="form.data.shifts.length<=1"
                                                @click="remove(i)"
                                        ><span class="fa fa-minus"></span></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-if="form.options.errors.shifts" class="has-error">
                                <span class="help-block"><p>{{trans('warehouseman.common.table.fill_all_fields')}}</p></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="btn btn-primary" @click="add()">
                                        <i class="fa fa-plus"></i>
                                        {{trans('warehouseman.common.table.add_position')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" @click="print()">
                                <i class="fa fa-print"></i>
                                {{trans('warehouseman.common.print')}}
                            </button>
                            <button type="button" class="btn btn-success spinner" :data-loading-text="loadingText" @click="execute()">
                                <i class="fa fa-arrow-right"></i>
                                {{trans('warehouseman.move.execute')}}
                            </button>
                            <button
                                v-if="areCheckedShifts"
                                type="button"
                                class="btn btn-success spinner"
                                :data-loading-text="loadingText"
                                @click="execute(true)"
                            >
                                <i class="fa fa-cart-arrow-down"></i>
                                {{trans('warehouseman.move.execute_and_close')}}
                            </button>
                            <button type="button" class="btn btn-default" data-dismiss="modal" @click="reset()">
                                {{trans('warehouseman.common.close')}}
                            </button>
                        </div>
                    </div>
                    <div v-show="loading > 0" class="modal-body">
                        <span>
                            <h2>{{ trans('form.please_wait') }}...</h2>
                            <ring-loader></ring-loader>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div id="print_move" class="print-block hide" data-name="move">
            <table class="table" style="width: 50%;">
                <tr>
                    <th>{{ trans('warehouseman.prepare.search.warehouse_from')}}</th>
                    <td>{{ form.data.warehouseFrom ? form.data.warehouseFrom.name : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.prepare.search.warehouse_to')}}</th>
                    <td>{{ form.data.warehouseTo ? form.data.warehouseTo.name : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.return.search.receiver')}}</th>
                    <td>{{ form.data.receiver ? form.data.receiver.username : '-' }}</td>
                </tr>
                <tr>
                    <th>{{ trans('warehouseman.return.search.deliver')}}</th>
                    <td>{{ form.data.deliver ? form.data.deliver.username : '-' }}</td>
                </tr>
            </table>
            <table class="table" style="margin-top: 30px; width: 100%; word-break: break-all;">
                <thead>
                <tr>
                    <th>{{ trans('warehouseman.move.table.object_type') }}</th>
                    <th>{{ trans('warehouseman.move.table.position') }}</th>
                    <th>{{ trans('warehouseman.move.table.unit') }}</th>
                    <th>{{ trans('warehouseman.move.table.meal') }}</th>
                    <th>{{ trans('warehouseman.move.table.expected') }}</th>
                    <th>{{ trans('warehouseman.move.table.prepared') }}</th>
                    <th>{{ trans('warehouseman.move.table.final') }}</th>
                    <th>{{ trans('warehouseman.move.table.execute') }}</th>
                    <th>{{ trans('warehouseman.move.table.description') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(shift, i) in form.data.shifts" :key="i">
                    <td>{{ translateObjectType(shift.objectType) }}</td>
                    <td>{{ shift.item.id ? shift.objectName : (shift.object ? shift.object.name : '-') }}</td>
                    <td>{{
                        translateUnit(
                            shift.item.id
                            ? shift.item.unit
                            : (shift.object ? (shift.object.unit ? shift.object.unit : 'piece') : null)
                        ) }}
                    </td>
                    <td>{{ shift.mealSelectName }}</td>
                    <td>{{ shift.item.amountExpected }}</td>
                    <td>{{ shift.item.amountPrepared ? shift.item.amountPrepared : 0 }}</td>
                    <td>{{ shift.item.amountFinal ? shift.item.amountFinal : 0 }}</td>
                    <td>{{ shift.amountToMove }}</td>
                    <td>{{ shift.description }}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import SimpleFormSingleSelect from '../../component/simple-form/singleselect.vue'
import DcCoreSingleSelect from '../../component/dccore-form/singleselect.vue'
import * as toastr from 'toastr'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import store from '../../store/warehouseman'
import warehousemanMixins from '../mixins/warehouseman-mixins'
import Checkbox from '../../component/dccore-form/checkbox.vue'

export default {
  components: {
    SimpleFormSingleSelect,
    DcCoreSingleSelect,
    RingLoader,
    Checkbox
  },
  mixins: [warehousemanMixins],
  store,
  props: {},
  data() {
    return {
      key: 0,
      loading: 0,
      loadingText : `<i class='fa fa-spinner fa-spin '></i>${Translator.trans('form.please_wait')}`,
      form: {
        data: this.defaultData(),
        options: {
          errors: {},
        },
        supplierName: null,
        errors: false,
      },
      areCheckedShifts: false,
      events: {
        done: function () {
        },
      },
    }
  },
  computed: {
    allowedMoveStatuses() {
      return this.$store.state.allowedMoveStatuses
    },
    allowedMoveTypes() {
      return this.$store.state.allowedMoveTypes
    },
    warehouses() {
      return this.$store.state.warehouses
    },
    users() {
      return this.$store.state.users
    },
    objectTypes() {
      return this.$store.state.objectTypes
    },
    objects() {
      return this.$store.state.objects
    },
    meals() {
      return this.$store.state.meals
    },
    currentUser() {
      return this.$store.state.currentUser
    },
    suppliers() {
      return this.$store.state.suppliers
    },
  },
  mounted: function () {
    $('.modal[data-name=move]').on('hidden.bs.modal', () => {
      $('.print-block[data-name=move]').removeClass('visible-print-block')
      this.events.done()
    })
  },
  methods: {
    warehouseSelected(warehouse) {
      if (warehouse) {
        this.$store.dispatch('fetchObjects', { warehouse })
          .then(() => this.$store.dispatch('fetchMeals'))
          .then(() => this.key += 1)
      }
    },
    defaultData() {
      return {
        receiver: null,
        deliver:  this.currentUser ? this.users.find(user => user.id === this.currentUser.id) : null,
        supplier: null,
        receiverId: null,
        deliverId: this.currentUser ? this.currentUser.id : null,
        supplierId: null,
        shifts: [],
        warehouseFrom: null,
        warehouseTo: null,
        externalIssue: false,
        closeMoving: false,
      }
    },
    init(items) {
      $('#popup_move').button('loading')
      return Promise.all([
        this.$store.dispatch('fetchAllowedMoveStatuses'),
        this.$store.dispatch('fetchAllowedMoveTypes'),
        this.$store.dispatch('fetchWarehouses'),
        this.$store.dispatch('fetchUsers'),
        this.$store.dispatch('fetchObjectTypes'),
        this.$store.dispatch('fetchCurrentUser'),
        this.$store.dispatch('fetchSuppliers'),
      ]).then(() => {
        $('#popup_move').button('reset')
        return new Promise((resolve, reject) => {
          this.reset()
          items = this.prepareInput(items)

          if (!items) {
            reject()
            return
          }

          this.getShifts(items)
            .then(() => {
              this.open()
              this.events.done = () => {
                resolve()
              }
            })
        })
      }).catch(() => {
        toastr.error(Translator.trans('global.messages.fetch_problem'))
      })
    },
    open() {
      $('.modal[data-name=move]').modal({
        backdrop: 'static',
        keyboard: false
      })
      $('.print-block[data-name=move]').addClass('visible-print-block')
    },
    close() {
      $('.modal[data-name=move]').modal('hide')
    },
    print() {
      this.printElement('print_move')
    },
    remove(i) {
      this.form.data.shifts.splice(i, 1)
      this.refresh()

      setTimeout(() => {
        this.$refs.sss.forEach(ref => {
          ref.value = ref.$attrs.value
        })
      }, 1)
    },
    add() {
      this.form.data.shifts.push(this.create())
    },
    create() {
      return {
        item: {},
      }
    },
    execute(closeMoving = false) {
      $('.spinner').button('loading')
      this.prepareDataToSend()
      this.form.data.closeMoving = closeMoving
      this.$http.patch(
        Routing.generate('api_warehouseman_patch_move'), this.form.data).then(
        () => {
          this.close()
          this.reset()
          this.events.done()
          $('.spinner').button('reset')
        },
        response => {
          this.handleAjaxError(response, this.form.options)
          $('.spinner').button('reset')
        }
      )
    },
    prepareInput(items) {
      let countBeforeFilter = items.length

      items = items.filter(item => {
        return this.allowedMoveStatuses.includes(item.status)
                        && this.allowedMoveTypes.includes(item.moveType)
      })

      if (items.length < countBeforeFilter) {
        toastr.error(Translator.trans('warehouseman.common.selected_invalid_shifts'))
        return
      }

      return items.map(item => {
        return item.id
      })
    },
    prepareDataToSend() {
      if (this.form.data.receiver) {
        this.form.data.receiverId = this.form.data.receiver.id
      }

      if (this.form.data.deliver) {
        this.form.data.deliverId = this.form.data.deliver.id
      }

      if (this.form.data.supplier) {
        this.form.data.supplierId = this.form.data.supplier.id
      }

      if (this.form.data.warehouseFrom) {
        this.form.data.warehouseFromId = this.form.data.warehouseFrom.id
      }

      if (this.form.data.warehouseTo) {
        this.form.data.warehouseToId = this.form.data.warehouseTo.id
      }

      this.form.data.shifts.forEach((shift, i) => {
        if (shift.object) {
          this.form.data.shifts[i].objectId = shift.object.id
        }
      })
    },
    getProductsEvent(event) {
      this.getProducts(event.$event.id)
    },
    getProducts(supplierId) {
      this.loading++

      this.$http.get(Routing.generate('api_get_products_buyable_by_supplier', {
        id: supplierId,
        context: 'dropdown'
      })).then(response => {
        this.form.options.products = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getSuppliers() {
      this.loading++
      let url = Routing.generate('api_get_suppliers_active', { context: 'dropdown' })

      Vue.http.get(url).then(response => {
        this.form.options.suppliers = response.data
        this.loading--
      }, response => {
        this.handleAjaxError(response)
        this.loading--
      })
    },
    getShifts(shiftsIds) {
      return new Promise((resolve, reject) => {
        let takenShifts = []

        if (shiftsIds && shiftsIds.length) {
          shiftsIds.forEach(id => {
            this.loading++
            this.$http.get(Routing.generate('api_warehouseman_get_move', { warehouseShift: id }))
              .then(response => {
                takenShifts.push(this.prepareItem(response.data))

                if (takenShifts.length === shiftsIds.length) {
                  if (!this.checkShifts(takenShifts)) {
                    this.loading--
                    toastr.error(Translator.trans('warehouseman.common.selected_invalid_shifts'))
                    reject()
                    return
                  }

                  resolve()

                  this.form.data.warehouseFrom = response.data.item.warehouseFrom
                  this.form.data.warehouseTo = response.data.item.warehouseTo

                  this.form.data.shifts = takenShifts.sort((shift1, shift2) => {
                    return shift1.objectName.toUpperCase().localeCompare(shift2.objectName.toUpperCase())
                  })

                  this.form.data.shifts.forEach((shift, i) => {
                    if (shift.unitPrice === null) {
                      this.updateUnitPrice(i, shift.objectId)
                    }
                  })
                }
                this.loading--
              }, response => {
                this.loading--
                this.handleAjaxError(response)
                reject()
              })
          })
          this.areCheckedShifts = true
        } else {
          this.areCheckedShifts = false
          this.add()
          resolve()
        }
      })
    },
    prepareItem(shift) {
      shift.amountToMove = Math.max(
        shift.item.amountExpected - (shift.item.amountFinal ? shift.item.amountFinal : 0),
        0
      )
      shift.description = shift.item.description
      shift.shiftId = shift.item.id
      shift.unitPrice = shift.item.unitPrice
      shift.objectType = shift.item.objectType
      return shift
    },
    checkShifts(shifts) {
      let from = shifts[0].item.warehouseFrom
      let to = shifts[0].item.warehouseTo
      let type = shifts[0].item.moveType
      this.form.data.externalIssue = type === 'out'
      let BreakException = {}

      try {
        shifts.forEach(shift => {
          // to move and to
          if (type !== shift.item.moveType) {
            throw BreakException
          }

          if (shift.item.warehouseFrom && shift.item.warehouseFrom.id !== from.id) {
            throw BreakException
          }

          if (type === 'move' && shift.item.warehouseTo.id !== to.id) {
            throw BreakException
          }

        })
      } catch (e) {
        if (e === BreakException) {
          return false
        }
      }

      return true
    },
    getUnit(event, shiftIndex) {
      this.form.data.shifts[shiftIndex].item.unit = event.$event.unit
      this.form.data.shifts[shiftIndex].item.unitWeight = event.$event.unitWeight

      this.updateUnitPrice(shiftIndex, event.$event.id)
    },
    updateUnitPrice(shiftIndex, productId) {
      if (this.form.data.shifts[shiftIndex].objectType === 'product') {
        Vue.http.get(
          Routing.generate('api_get_warehouse_shift_latest_product_move_in_unit_price', { product: productId })
        ).then(response => {
          this.form.data.shifts[shiftIndex].unitPrice = response.data.unit_price
          this.$forceUpdate()
        })
      }
    }
  },
}
</script>
